import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import statusIcon from '../../../assets/img/statusIcon.svg';
import calendarIcon from '../../../assets/img/icons/Calendar.svg';
import assigneeIcon from '../../../assets/img/icons/assignee.svg';
import officeIcon from '../../../assets/img/Sidebar/offices-icon.svg';
import tickGreen from '../../../assets/img/icons/tick-green.svg';
import { CheckListStatus } from 'styledComponents/tasks';
import ComponentCircleLoader from 'components/Loaders/ComponentCircleLoader';
import NoDataComponent from 'components/NoDataComponent/NoDataComponent';
import TaskEvidence from '../TaskDetails/taskEvidence';
import {
    FullWidthWithTopBorder,
    TaskDetailsInfoSection,
    LabelTextBlock,
} from '../TaskDetails/taskDetailsStyles';
import { TaskDetailsSingleInfo } from '../TaskDetails/TaskDetails';
import BackButtonComponent from '../../../components/BackButtonComponent/BackButtonComponent';
import StaticTaskLocationModal from 'custom_modules/TaskLocations/StaticTaskLocationModal';
import {
    CommonFlex,
    CommonText,
    Container,
    PageTitle,
    ContentHeader,
    FirstWordRound,
    ColoredText,
    InputLabel,
} from 'styledComponents/common';
import {
    HistoryContainer,
    HistoryHeader,
    HistoryRowWrapper,
    HistoryMainRow,
    HistoryContent,
    EvidenceBox,
    CircularArrow,
} from './subTaskDetailsStyles';
import { ExpandIcon, ProjectExpandButton } from 'custom_modules/Projects/projectsStyles';
import arrowWhiteIcon from '../../../assets/img/icons/arrow_right_white.svg';
import Status from 'components/Status/Status';

const SubTaskDetails = ({
    getSubTaskDetails,
    subTaskDetails: realSubTaskDetails,
    isLoading,
    id,
    history: routerHistory,
}) => {
    const { t } = useTranslation();
    const [expandedHistoryId, setExpandedHistoryId] = useState(null);
    const [seeLocationModalOpen, setSeeLocationModalOpen] = useState(false);
    const [selectedTaskLocation, setSelectedTaskLocation] = useState(null);

    const subTaskDetails = realSubTaskDetails;

    const handleExpandBudgetSection = taskId => {
        if (expandedHistoryId && expandedHistoryId === taskId) {
            setExpandedHistoryId(null);
        } else {
            setExpandedHistoryId(taskId);
        }
    };

    const handleShowLocation = (location) => {
        setSelectedTaskLocation(location);

        setTimeout(() => {
            setSeeLocationModalOpen(true);
        }, 300);
    };

    useEffect(() => {
        if (id) {
            getSubTaskDetails({ id });
        }
    }, [id, getSubTaskDetails]);

    // Initialize expandedHistoryId with the first history item ID once data is loaded
    useEffect(() => {
        if (realSubTaskDetails?.history?.length > 0 && !expandedHistoryId) {
            setExpandedHistoryId(realSubTaskDetails.history[0].id);
        }
    }, [realSubTaskDetails]);

    if (isLoading) {
        return <ComponentCircleLoader />;
    }

    if (!subTaskDetails) {
        return (
            <NoDataComponent
                title={t('no_subtask_details_found')}
                padding="5vh 0"
                imageHeight="140px"
            />
        );
    }

    const toggleHistory = (hid) => {
        setExpandedHistoryId(expandedHistoryId === hid ? null : hid);
    };
    
    return (
        <div className="content">
            <StaticTaskLocationModal
                isOpen={seeLocationModalOpen}
                toggle={() => {
                    setSeeLocationModalOpen(false);
                    setSelectedTaskLocation(null);
                }}
                taskLocation={selectedTaskLocation}
            />
            <PageTitle>{t('subtask_details')}</PageTitle>
            <ContentHeader>
                <BackButtonComponent
                    onClick={() => routerHistory.push('/user/sub-tasks')}
                    subTitle={t('back_to_all_subtasks')}
                />
            </ContentHeader>

            <Container padding="30px" gap="20px">
                <CommonFlex gap="10px" direction="column" alignItems="flex-start">
                    <CommonText name title fontSize="20px">
                        {subTaskDetails.name}
                    </CommonText>
                </CommonFlex>

                <TaskDetailsInfoSection>
                    <TaskDetailsSingleInfo
                        icon={statusIcon}
                        title="status"
                        value={
                            <CommonFlex gap="10px">
                                {subTaskDetails.status && (
                                    // <CheckListStatus
                                    //     status={subTaskDetails.status.toLowerCase().includes('completed') ? 'completed' : 'pending'}
                                    // >
                                    //     {i18next.language && i18next.language === 'en'
                                    //         ? t(subTaskDetails.status).toUpperCase()
                                    //         : t(subTaskDetails.status)}
                                    // </CheckListStatus>
                                    <Status  status={subTaskDetails.status ? subTaskDetails.status ==="to do" ? '0' : subTaskDetails.status : '0'} />
                                )}
                            </CommonFlex>
                        }
                    />

                    <TaskDetailsSingleInfo
                        icon={officeIcon}
                        title="public_zone"
                        value={<CommonText name>{subTaskDetails.public_zone_name || t('no_public_zone')}</CommonText>}
                    />

                    <TaskDetailsSingleInfo
                        icon={officeIcon}
                        title="office"
                        value={<CommonText name>{subTaskDetails.zone_name || t('no_office')}</CommonText>}
                    />

                    <TaskDetailsSingleInfo
                        icon={assigneeIcon}
                        title={t('updated_by')}
                        value={
                            subTaskDetails.updated_by ? (
                                <CommonFlex gap="10px">
                                    <FirstWordRound size="30px"
                                        fontSize="11px"
                                        backColor="#789CFF">
                                        {subTaskDetails.updated_by.first_name.slice(0, 1)}
                                    </FirstWordRound>
                                    <CommonText name>
                                        {subTaskDetails.updated_by.first_name} {subTaskDetails.updated_by.last_name}
                                    </CommonText>
                                </CommonFlex>
                            ) : (
                                <CommonText>-</CommonText>
                            )
                        }
                    />

                    <TaskDetailsSingleInfo
                        icon={calendarIcon}
                        title="updated_at"
                        value={
                            <CommonText name>
                                {subTaskDetails.history?.[0]?.created_at ? new Date(subTaskDetails.history[0].created_at).toLocaleString() : '-'}
                            </CommonText>
                        }
                    />
                </TaskDetailsInfoSection>

                <div>
                    <CommonText title fontSize="16px">{t('location')}</CommonText>
                    <LabelTextBlock style={{ marginTop: '10px' }}>
                        <InputLabel>{t('location_address')}:</InputLabel>
                        <CommonText name>{subTaskDetails?.location?.address}</CommonText>
                    </LabelTextBlock>
                    {subTaskDetails?.location && (
                        <ColoredText
                            type="warning"
                            hover
                            onClick={() => handleShowLocation(subTaskDetails?.location)}
                            fontSize="14px"
                            style={{ cursor: 'pointer' }}
                        >
                            {t('see_location')}
                        </ColoredText>
                    )}
                </div>

                <FullWidthWithTopBorder>
                    <TaskEvidence evidences={subTaskDetails?.evidences} />
                </FullWidthWithTopBorder>

                <FullWidthWithTopBorder>
                    <CommonText title fontSize="16px">{t('comments')}</CommonText>
                    {subTaskDetails.employee_note && (
                        <div style={{ marginTop: '10px' }}>
                            <CommonText title fontSize="14px" secondary>{t('employee_note')}</CommonText>
                            <CommonText>{subTaskDetails.employee_note}</CommonText>
                        </div>
                    )}
                </FullWidthWithTopBorder>

                <FullWidthWithTopBorder max="100%">
                    <CommonText title fontSize="18px">{t('history')}</CommonText>
                    <HistoryContainer>
                        <HistoryHeader>
                            <div></div>
                            <div>{t('Name')}</div>
                            <div>{t('Updated at')}</div>
                            <div>{t('Status')}</div>
                            <div>{t('Evidence')}</div>
                        </HistoryHeader>
                        {subTaskDetails.history && subTaskDetails.history.map(item => (
                            <HistoryRowWrapper key={item.id}>
                                <HistoryMainRow onClick={() => toggleHistory(item.id)}>
                                    <img src={tickGreen} alt="" width="20px" />
                                    <CommonText name fontSize="14px">{subTaskDetails?.name}</CommonText>
                                    <div>
                                        <CommonText fontSize="14px">{item.created_at ? new Date(item.created_at).toLocaleDateString() : ''}</CommonText>
                                        <CommonText fontSize="13px" secondary>{item.created_at ? new Date(item.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}</CommonText>
                                    </div>
                                    {/* <CheckListStatus
                                        status={item.status ? (item.status.toLowerCase().includes('completed') ? 'completed' : 'pending') : 'pending'}
                                        fontSize="12px"
                                        padding="4px 10px"
                                    >
                                        {item.status ? item.status.toUpperCase() : ''}
                                    </CheckListStatus> */}
                                    <Status status={item.status === 'to do' ? '0' : item.status === 'completed' ? 'Completed 100' : item.status} />
                                    <CommonFlex gap="12px" wrap="wrap">
                                        <ProjectExpandButton
                                            margin="0"
                                            onClick={() => handleExpandBudgetSection(item.id)}
                                        >
                                            <ExpandIcon
                                                src={arrowWhiteIcon}
                                                alt=""
                                                open={expandedHistoryId && expandedHistoryId === item.id}
                                            />
                                        </ProjectExpandButton>

                                    </CommonFlex>
                                </HistoryMainRow>
                                {expandedHistoryId === item.id && (
                                    <HistoryContent>
                                        <EvidenceBox>
                                            {item.evidences ? (
                                                <TaskEvidence evidences={item.evidences} />
                                            ) : (
                                                <CommonText secondary>{t('No evidences found')}</CommonText>
                                            )}
                                        </EvidenceBox>
                                        <div>
                                            <CommonText title fontSize="16px" style={{ marginBottom: '10px' }}>{t('comments')}</CommonText>
                                            <div style={{ marginLeft: '10px' }}>
                                                <CommonText title fontSize="14px" secondary style={{ marginBottom: '5px' }}>{t('employee_note')}</CommonText>
                                                <CommonText>{item.employee_note || t('no_notes_found')}</CommonText>
                                            </div>
                                        </div>
                                    </HistoryContent>
                                )}
                            </HistoryRowWrapper>
                        ))}
                    </HistoryContainer>
                </FullWidthWithTopBorder>
            </Container>
        </div>
    );
};

export default SubTaskDetails;
